import React from 'react';
import cx from '../../styles';

const Placeholder = ({h, w}) => {
    return (
        <div className={cx("")} style={{width: w, height: h}}>
        </div>
    );
};

export default Placeholder;